//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      failingFields: [],
      formData: {
        locations: [],
        organic_matter_content: [1, 10],
        moisture_content: [1, 10],
        warranty: null,
        herbs_to_grass_percentage: 50,
        species_to_sown_percentage: 50,
      },
      newLocationForm: {},
      defaultNewLocationForm: {
        title: '',
        surface: '',
        warranty: null,
        herbs_to_grass_percentage: 50,
        species_to_sown_percentage: 50,
      },
      currentTab: 1,
    };
  },
  computed: {
    failingTab() {
      if (this.failingFields.length === 0) {
        return null;
      }

      if (this.failingFields.some(f => ['new_location_title', 'new_location_surface'].includes(f))) {
        if (this.failingFields.every(f => ['new_location_title', 'new_location_surface'].includes(f))) {
          return 2;
        }
      }

      return 1;
    },
  },
  mounted() {
    this.newLocationForm = JSON.parse(JSON.stringify(this.defaultNewLocationForm));
  },
  methods: {
    handleInvalid(failingFields) {
      this.failingFields = Object.keys(failingFields);

      if (this.failingTab) {
        this.currentTab = this.failingTab;
      }
    },
    addLocation() {
      if (!this.newLocationForm.title || !this.newLocationForm.surface) {
        return;
      }
      const parsed = JSON.parse(JSON.stringify(this.newLocationForm));
      parsed.surface = parseInt(parsed.surface);
      this.formData.locations.push(parsed);
      this.newLocationForm = this.defaultNewLocationForm;
    },
    deleteLocation(index) {
      this.formData.locations.splice(index, 1);
    },
    updateLocationSpecies(index, species) {
      this.formData.locations[index].species = species.map(s => s.uuid);
    },
    submit() {
      this.$emit('submit', this.parseData(this.formData));
    },
    parseData(data) {
      return {
        title: data.title,
        client: data.client.uuid,
        locations: data.locations,
        project_number: data.project_number,
        project_surface: parseInt(data.project_surface),
        city: data.city,
        since: data.since,
        district: data.district,
        material: data.material,
        moisture_content_min: data.moisture_content[0] || 1,
        moisture_content_max: data.moisture_content[1] || 1,
        sun: data.sun,
        organic_matter_content_min: data.organic_matter_content[0] || 1,
        organic_matter_content_max: data.organic_matter_content[1] || 1,
        lime_content: data.lime_content,
        monitoring_per_year: data.monitoring_per_year,
        mowing_and_cleaning: data.mowing_and_cleaning,
        contract_until: parseInt(data.contract_until),
        warranty: data.warranty,
        herbs_to_grass_percentage: parseInt(data.herbs_to_grass_percentage),
        species_to_sown_percentage: parseInt(data.species_to_sown_percentage),
        ...(data.thumbnail?.files[0]?.file) ? {thumbnail: data.thumbnail.files[0].file} : {},
      };
    },
  },
};
